import type {
  DatadogDevtools,
  DatadogProvider,
} from '@datadog/openfeature-browser';

// The real Datadog provider (holds the fetched endpoint config) and the devtools
// wrapper (applies local overrides). Both null until initFlags runs.
//
// These live here rather than in init.ts so that overrides.ts and reads.ts can
// reach them without importing init.ts, which would form a cycle.
let datadogProvider: DatadogProvider | null = null;
let devtoolsProvider: DatadogDevtools | null = null;

export const setProviders = (
  real: DatadogProvider | null,
  devtools: DatadogDevtools,
) => {
  datadogProvider = real;
  devtoolsProvider = devtools;
};

export const getDatadogProvider = () => datadogProvider;
export const getDevtoolsProvider = () => devtoolsProvider;
